<common-internal-header [navigationItems]="navigationItems"></common-internal-header>
<main role="main" [class.container]="addContainerClass" [class.container-fluid]="!addContainerClass">
  <router-outlet></router-outlet>
</main>
